<div id="p_prldr" (click)="goToMap()">
    <div class="contpre">
        <span class="svg_anm"></span>
    </div>
</div>